import { useCommunityContext } from '@/providers/community-context';
import { isAggregatorKind } from '@/lib/community-ui-mode';
import AggregatorSettingsPage from '@/pages/settings/AggregatorSettingsPage';
import CommunitySettingsPage from '@/pages/settings/CommunitySettingsPage';

export default function CommunitySettingsRouter() {
  const { community } = useCommunityContext();

  if (isAggregatorKind(community.kind)) {
    return <AggregatorSettingsPage />;
  }

  return <CommunitySettingsPage />;
}
